import { API_ENDPOINTS } from './Constants';
import { apiFetch } from './apiHelper';

export async function getDashboardStats() {
    const res = await apiFetch(API_ENDPOINTS.DASHBOARD_STATS, { method: 'GET' });
    if (!res.ok) throw new Error('Greška kod dohvata statistika');
    return res.json();
}
